import { IconChevronRight, IconList, IconLoader2, IconLogout, IconMoon, IconSettings, IconSun } from '@tabler/icons-react'
import React from 'react'
import { useConfigurationRQ } from '../queryState/configuration.state'
import { Link } from 'react-router-dom'
import { useSideNavAPI } from '../API/sideNavAPI'
import { ButtonIconSquare, ButtonRounded } from './buttons'
import { useDarkmodeAPI } from '../API/darkmodeAPI'
import { useAuthenticationHook } from 'src/API/rest.authentication'

export default function NavBar() {
    const { showSideNav } = useSideNavAPI()
    const { logoutAdmin, isLogoutAdminPending } = useAuthenticationHook()
    const { mode, toggleDarkMode } = useDarkmodeAPI()

    return (
        <nav className="h-16 px-6 flex items-center justify-between">
            {/* Left section */}
            <div className="flex items-center space-x-6">
                {/* Mobile menu button */}
                <button 
                    className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 lg:hidden"
                    onClick={showSideNav}
                >
                    <IconChevronRight className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                </button>

                {/* Navigation links */}
                <div className="hidden md:flex items-center space-x-6">
                    <Link 
                        className="text-sm font-medium text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white transition-colors" 
                        to=""
                    >
                        File
                    </Link>
                    <Link 
                        className="text-sm font-medium text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white transition-colors" 
                        to=""
                    >
                        Department
                    </Link>
                    <Link 
                        className="text-sm font-medium text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white transition-colors" 
                        to=""
                    >
                        Sales
                    </Link>
                </div>
            </div>

            {/* Right section - Actions */}
            <div className="flex items-center space-x-3">
                <button
                    onClick={() => logoutAdmin()}
                    disabled={isLogoutAdminPending}
                    className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                >
                    {isLogoutAdminPending ? (
                        <IconLoader2 className="w-5 h-5 text-gray-600 dark:text-gray-300 animate-spin" />
                    ) : (
                        <IconLogout className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                    )}
                </button>
                
                <button className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                    <IconSettings className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                </button>
                
                <button 
                    onClick={toggleDarkMode}
                    className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                >
                    {mode === 'dark' ? (
                        <IconMoon className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                    ) : (
                        <IconSun className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                    )}
                </button>
            </div>
        </nav>
    )
}
